import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import {
    ContentSuggestionPayload,
    isContentSuggestionPayload,
    isModifiersPayload,
} from 'components/Filters/context/SearchBarContext/types';
import { ModifiersPayload } from 'controllers/SearchController/types';
import getFilterParamsToType from './helpers/getFilterParamsToType';
import {
    CreateUserRecentSearch,
    GetUserRecentSearch,
} from './userRecentSearch.gql';

export const useCreateUserRecentSearch = ({
    isAuthenticated,
}: {
    isAuthenticated: boolean;
}) => {
    const [createUserRecentSearch] = useMutation(CreateUserRecentSearch, {
        refetchQueries: [
            {
                query: GetUserRecentSearch,
            },
        ],
        onError: () => {
            // Do nothing
        },
    });

    const handleCreateUserRecentSearch = useCallback(
        (modifiers: (ModifiersPayload | ContentSuggestionPayload)[]) => {
            if (!isAuthenticated) {
                return;
            }

            modifiers.forEach((modifier) => {
                if (isContentSuggestionPayload(modifier)) {
                    const [params, payload] = modifier;
                    const filterType = getFilterParamsToType(params);

                    if (filterType && payload.slug) {
                        createUserRecentSearch({
                            variables: {
                                filterType,
                                filterSlug: payload.slug,
                            },
                        });
                    }
                } else if (isModifiersPayload(modifier)) {
                    const [params, payload] = modifier;
                    const filterType = getFilterParamsToType(params);

                    if (filterType && payload) {
                        createUserRecentSearch({
                            variables: {
                                filterType,
                                filterSlug: payload,
                            },
                        });
                    }
                }
            });
        },
        [createUserRecentSearch, isAuthenticated],
    );

    return handleCreateUserRecentSearch;
};
